function resolveApiUrl(): string {
  // 1. Variable de entorno definida en tiempo de build (Prioridad alta)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // 2. Verificar el entorno del navegador si está disponible
  if (typeof window !== 'undefined') {
    const { hostname } = window.location;

    // Desarrollo local en PC
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:8000/api';
    }

    // Si estás abriendo la web real en producción desde el navegador
    if (hostname === 'mireferido.com.co') {
      return 'https://mireferido.com.co/api';
    }
  }

  // 3. RESPALDO PARA CAPACITOR (APK)
  // Si no es localhost, y no estás en el navegador web directo, 
  // significa que la app corre dentro del WebView del celular.
  // Aquí FORZAMOS la URL absoluta de Hostinger.
  return 'https://mireferido.com.co/api';
}

export const API_BASE_URL = resolveApiUrl();

// Header Authorization con el JWT guardado al iniciar sesión
export const authHeaders = (): Record<string, string> => ({
  'Authorization': `Bearer ${localStorage.getItem('token') ?? ''}`,
});
